import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import DisputeCheckIcon from "../Assets/DisputeCheckIcon.svg";
import DisputeAdminReview from "../Assets/DisputeAdminReview.svg";
import VLIAdminReview from "../Assets/VLIAdminReview.svg";
import DisputeSettled from "../Assets/DisputeSettled.svg";
import { GetSettingsOpenDisputeData } from "../../../Actions/StudentA";
import { useNavigate } from "react-router-dom";

const OpenDisputeHistory = ({UserId, setEnrolledCourses}) => {
    const Dispatch = useDispatch();
    const navigate = useNavigate();
    const Border = "border-[#E2E2E2] border-[1px] border-solid";

    const { UserOpenDisputeData } = useSelector((Store) => Store.StudentReducer);
    console.log("UserOpenDisputeData is:",UserOpenDisputeData)

    useEffect(() => {
        if (UserId) {
          Dispatch(GetSettingsOpenDisputeData(UserId));
        }
      }, [UserId, Dispatch]);

      useEffect(() => {
        if (UserOpenDisputeData && UserOpenDisputeData.length > 0) {
            const courses = UserOpenDisputeData.map(item => item.EnrolledCourseDispute);
            setEnrolledCourses(courses);
        }
    }, [UserOpenDisputeData]);

      const handleRedirect = () => {
        navigate("/inbox"); // Redirect to /inbox
      };
   
    return (
        <>
            {UserOpenDisputeData ? (
            <div className="w-full flex flex-col justify-center items-center gap-[10px]">
                <div className="w-[85%] flex flex-start">
                    <p className="text-[#404040] text-[20px] font-bold">Dispute History</p>
                </div>
                {UserOpenDisputeData?.map((dispute, index) => (
                <div key={index} className="w-full lg:w-[85%] flex flex-col gap-[20px] bg-[#F8FAFA] rounded-[9px] px-[10px] lg:px-[20px] py-[20px]">
                    <p className="text-[#404040] text-[20px] font-bold">{dispute.disputeSubject}</p>
                    <p className="text-[#404040] text-[18px]">Dispute ID: {dispute.DisputeId}</p>
                    <div className="w-full flex justify-center items-center mt-[20px]">
                        <div className="w-full lg:w-[93%] flex flex-col lg:flex-row justify-center items-center lg:justify-start lg:items-start gap-[10px]">
                            <div className="flex flex-row lg:flex-col gap-[10px] lg:gap-[5px] justify-center items-center">
                                <img src={DisputeCheckIcon} alt="CheckIcon" />
                                <div className="flex flex-col gap-[5px]">
                                    <p className="text-[#404040] text-[18px] font-bold">Dispute Created</p>
                                    <p className="text-[#404040] text-[16px] text-center w-[160px]">
                                        New Dispute has been created on {new Date(dispute.createdAt).toLocaleDateString()}
                                    </p>
                                </div>
                            </div>
                            <div className="hidden lg:block h-[4px] w-[30%] bg-[#A1A3EF] rounded-full mt-[27px] ml-[-50px]"></div>
                            <div className=" lg:hidden h-[100px] w-[4px] bg-[#A1A3EF] rounded-full"></div>
                            
                            <div className="flex flex-row lg:flex-col gap-[10px] lg:gap-[5px] justify-center items-center lg:ml-[-45px]">
                                <img
                                    src={
                                    dispute.DisputeStatus === "SchoolAdminReview" ||
                                    dispute.DisputeStatus === "VLIAdminReview" ||
                                    dispute.DisputeStatus === "Resolved"
                                        ? DisputeCheckIcon
                                        : DisputeAdminReview
                                    }
                                    alt="Admin Review"
                                />
                                <div className="flex flex-col gap-[5px]">
                                    <p className="text-[#404040] text-[18px] font-bold">School Admin Review</p>
                                    <p className="text-[#404040] text-[16px] text-center w-[180px]">
                                        Dispute Forwarded to School Admin for Their Review.
                                    </p>
                                </div>
                            </div>
                            <div className="hidden lg:block h-[4px] w-[30%] bg-[#A1A3EF] rounded-full mt-[27px] ml-[-50px]"></div>
                            <div className=" lg:hidden h-[100px] w-[4px] bg-[#A1A3EF] rounded-full"></div>

                            <div className="flex flex-row lg:flex-col gap-[10px] lg:gap-[5px] justify-center items-center lg:ml-[-45px]">
                            <img
                                src={dispute.DisputeStatus === "VLIAdminReview" || dispute.DisputeStatus === "Resolved"
                                    ? DisputeCheckIcon
                                    : VLIAdminReview
                                }
                                alt="VLI Admin Review"
                            />
                                <div className="flex flex-col gap-[5px]">
                                    <p className="text-[#404040] text-[18px] font-bold">VLI Admin Review</p>
                                    <p className="text-[#404040] text-[16px] text-center w-[160px]">
                                        Dispute Presented to VLI admin for final review.
                                    </p>
                                </div>
                            </div>
                            <div className="hidden lg:block h-[4px] w-[30%] bg-[#A1A3EF] rounded-full mt-[27px] ml-[-50px]"></div>
                            <div className=" lg:hidden h-[100px] w-[4px] bg-[#A1A3EF] rounded-full"></div>

                            <div className="flex flex-row lg:flex-col gap-[10px] lg:gap-[5px] justify-center items-center lg:ml-[-45px]">
                                <img
                                    src={dispute.DisputeStatus === "Resolved"
                                        ? DisputeCheckIcon
                                        : DisputeSettled
                                    }
                                    alt="Dispute Settled"
                                />
                                <div className="flex flex-col gap-[5px]">
                                    <p className="text-[#404040] text-[18px] font-bold">Dispute Settled</p>
                                    <p className="text-[#404040] text-[16px] text-center w-[160px]">
                                        Dispute Comments.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="w-full flex flex-col lg:flex-row justify-between items-center gap-[20px] mt-[10px]">
                        <p className="text-[#404040] text-[18px] text-center lg:text-start w-full lg:w-[80%]">
                            A dispute conversation group has been set up for you. Share your questions and track updates in this group. Click the "Conversation" button to start Chatting.
                        </p>
                        <button className="w-[200px] h-[44px] rounded-[8px] bg-[#A1A3EF] text-[#FFFFFF] text-[20px] lg:w-[20%]"
                        onClick={handleRedirect}>
                            Conversation
                        </button>
                    </div>
                </div>
                ))}     

            </div>
            ) : (
                <>
                </>
            )
            }
        </>
    );
};

export default OpenDisputeHistory;
